import { render, staticRenderFns } from "./ProductInfoBrand.vue?vue&type=template&id=22d2bb77&scoped=true&"
import script from "./ProductInfoBrand.vue?vue&type=script&lang=js&"
export * from "./ProductInfoBrand.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoBrand.vue?vue&type=style&index=0&id=22d2bb77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2bb77",
  null
  
)

export default component.exports